$ = require('jquery');
require('./jquery.easing');
require('./jquery.jgestures');

"use strict";

var PLUGIN_NAME = "webslider";

var DEFAULTS = {
	minScreenWidth: 320,
	data: [],
	sliderContentFormatter: function(data) {
	},
	slideContentFormatter: function(slideData) {
		var result = '';
		var resultCooperationAwards = '';
		var resultText1 = '';
		var resultText2 = '';
		var slideAnimation = '';

		if ((slideData.iea && slideData.iea !== '') || (slideData.webtop100 && slideData.webtop100 !== '') || (slideData.zlatyerb && slideData.zlatyerb !== '') || (slideData.zlatystrednik && slideData.zlatystrednik !== '') || (slideData.fenix && slideData.fenix !== '')) {
			slideAnimation = true;
			resultCooperationAwards = '<ul class="slide__infobox__list">\n';
			if (slideData.iea && slideData.iea !== '') {
				resultCooperationAwards += '  <li class="slide__infobox__item"><img class="svg-icon" src="/ver/20180718/img/klienti/iea.svg" width="75" height="75" alt="" /><span class="slide__infobox__year">' + slideData.iea + '</span></li>\n';
			}
			if (slideData.webtop100 && slideData.webtop100 !== '') {
				resultCooperationAwards += '  <li class="slide__infobox__item"><img class="svg-icon" src="/ver/20180718/img/klienti/webtop100.svg" width="75" height="75" alt="" /><span class="slide__infobox__year">' + slideData.webtop100 + '</span></li>\n';
			}
			if (slideData.zlatyerb && slideData.zlatyerb !== '') {
				resultCooperationAwards += '  <li class="slide__infobox__item"><img class="svg-icon" src="/ver/20180718/img/klienti/zlaty-erb.svg" width="75" height="75" alt="" /><span class="slide__infobox__year">' + slideData.zlatyerb + '</span></li>\n';
			}
			if (slideData.zlatystrednik && slideData.zlatystrednik !== '') {
				resultCooperationAwards += '  <li class="slide__infobox__item"><img class="svg-icon" src="/ver/20180718/img/klienti/zlaty-strednik.svg" width="75" height="75" alt="" /><span class="slide__infobox__year">' + slideData.zlatystrednik + '</span></li>\n';
			}
			if (slideData.fenix && slideData.fenix !== '') {
				resultCooperationAwards += '  <li class="slide__infobox__item"><img class="svg-icon" src="/ver/20180718/img/klienti/zlaty-fenix.svg" width="75" height="75" alt="" /><span class="slide__infobox__year">' + slideData.fenix + '</span></li>\n';
			}
			resultCooperationAwards += '</ul>\n';
/*
		} else if (slideData.cooperation && slideData.cooperation !== '') {
			resultCooperationAwards = '<ul class="slide__infobox__list">\n\t<li class="slide__infobox__item"><img class="svg-icon" src="/ver/20180718/img/klienti/spoluprace_' + web.lang + '.svg" width="75" height="75" alt="" /><span class="slide__infobox__year slide__infobox__year--cooperation">' + slideData.cooperation + '</span></li>\n</ul>\n';
*/
		}
		if (slideData.text1 && slideData.text1 !== '') {
			resultText1 = '<p class="slide__infobox__text slide__infobox__text--text1">' + slideData.text1 + '</p>\n';
		}
		if (slideData.text1 && slideData.text2 !== '') {
			resultText2 = '<p class="slide__infobox__text slide__infobox__text--text2">' + slideData.text2 + '</p>\n';
		}

		result = '	<div class="slide">\n';
		result += '		<div class="bg-rwd js_state-active' + ((slideData.itemLink && slideData.itemLink !== '') ? ' with-link' : '') + '" data-bg-rwd="'+slideData.activeImage['bg-rwd']+'" data-bg-rwd-320="'+slideData.activeImage['bg-rwd-320']+'" data-bg-rwd-540="'+slideData.activeImage['bg-rwd-540']+'" data-bg-rwd-660="'+slideData.activeImage['bg-rwd-660']+'" data-bg-rwd-828="'+slideData.activeImage['bg-rwd-828']+'" data-bg-rwd-1052="'+slideData.activeImage['bg-rwd-1052']+'" data-bg-rwd-1260="'+slideData.activeImage['bg-rwd-1260']+'"' + ((slideData.itemLink && slideData.itemLink !== '') ? ' data-slide-link="' + slideData.itemLink + '"' : '') + (slideData.blank ? ' data-slide-link-blank="' + slideData.blank+ '"' : '') + '>\n';
		if (slideData.text1 && slideData.text1 !== '') {
			result += ' 		<div class="slide__infobox' + ((slideData.position && slideData.position !== '') ? ' slide__infobox--' + slideData.position : '') + ((slideData.iea && slideData.iea !== '') || (slideData.webtop100 && slideData.webtop100 !== '') || (slideData.zlatyerb && slideData.zlatyerb !== '') || (slideData.zlatystrednik && slideData.zlatystrednik !== '') || (slideData.fenix && slideData.fenix !== '') ? ' slide__infobox--hasValuation' : '') + ' js_slideInfobox">\n';
			result += '	  	  <h2 class="slide__infobox__title js_slideInfoboxTitle">' + slideData.name + '</h2>\n';
			result += '	  	  <div class="slide__infobox__content">\n';
			result += resultText1;
			if (slideAnimation) {
				result += '	  	    <div class="slide__infobox__animation slide__infobox__animation--bigger">\n';
			} else {
				result += '	  	    <div class="slide__infobox__animation">\n';
			}
			result += resultText2;
			result += resultCooperationAwards;
			result += '		    </div>\n';
			result += '		  </div>\n';
			result += '		</div>\n';
		}
		result += '		</div>\n';
		result += '		<div class="bg-rwd js_state-inactive' + ((slideData.itemLink && slideData.itemLink !== '') ? ' with-link' : '') + '" data-bg-rwd="'+slideData.inactiveImage['bg-rwd']+'" data-bg-rwd-320="'+slideData.inactiveImage['bg-rwd-320']+'" data-bg-rwd-540="'+slideData.inactiveImage['bg-rwd-540']+'" data-bg-rwd-660="'+slideData.inactiveImage['bg-rwd-660']+'" data-bg-rwd-828="'+slideData.inactiveImage['bg-rwd-828']+'" data-bg-rwd-1052="'+slideData.inactiveImage['bg-rwd-1052']+'" data-bg-rwd-1260="'+slideData.inactiveImage['bg-rwd-1260']+'"' + ((slideData.itemLink && slideData.itemLink !== '') ? ' data-slide-link="' + slideData.itemLink + '"' : '') + (slideData.blank  ? ' data-slide-link-blank="' + slideData.blank + '"' : '') + '></div>\n';
		result += '	</div>\n';
		return result;
	},
	slidesWrapperSelector: null,
	sliderWrapperSelector: null,
	controlArrows: true,
	controlPoints: true,
	slideTime: 8000,
	slideAnimationTime: 1000,
	slideAnimationEasing: 'easeInOutQuad',
	autostart: true,
	startingSlide: 0,
	customCallback: function() {

	}
};

// The actual plugin constructor
function WebSlider(element, options) {
	this.element = element;
	this.$t = $(this.element);

	this.options = $.extend(true, {}, DEFAULTS, options);
	this._wWidth = window.innerWidth || window.document.body.clientWidth;
	this._slides = [];
	this._animationInProgress = false;

	this._defaults = DEFAULTS;
	this._name = PLUGIN_NAME;

	this._changeTimer = null;

	this.initialise();
}

/**
 * init
 */
WebSlider.prototype.initialise = function() {
	if (this._wWidth < this.options.minScreenWidth) {
		this.$t.empty().hide();
		return false;
	}

	this.$t.show();
	this.actualSlide = this.options.startingSlide;
	this.slidesWrapper = null;
	this.sliderWrapper = null;

	if (this.options.data.length > 0) {
		this.renderSlider();
		this.renderSlides();
	}

	if (this.options.data.length > 1) {
		this.renderControls();
		this.bindTouchEvents();

		if (this.options.autostart) {
			this.startRotation();
		}

		this.$t.trigger('WEBSLIDER_INIT', [this.options.data[this.getPreviousSlideIndex(1)], this.options.data[this.getNextSlideIndex(1)]]);
	}

	if ($.isFunction(this.options.customCallback)) {
		this.options.customCallback.call(this);
	}
};

/**
 * render slider, set wrappers
 */
WebSlider.prototype.renderSlider = function() {
	var htmlResult = this.options.sliderContentFormatter();

	this.$t.html(htmlResult);
	this.sliderWrapper = $(this.options.sliderWrapperSelector, this.$t);
	this.slidesWrapper = $(this.options.slidesWrapperSelector, this.$t);
};

/**
 * read data and build slides list
 */
WebSlider.prototype.renderSlides = function() {
	var $slide = null;
	var animationBoxHeight = '42px';

	for (var i = 0; i < this.options.data.length; i++) {
		$slide = $(this.options.slideContentFormatter(this.options.data[i]));
		this._slides.push($slide);
		$slide.appendTo(this.slidesWrapper);
	}

	this._slides[this.actualSlide].addClass('active');
	this._slides[this.getPreviousSlideIndex(1)].addClass('previous-slide');
	this._slides[this.getNextSlideIndex(1)].addClass('next-slide');

	if ($('.slide__infobox__animation', this._slides[this.actualSlide]).hasClass('slide__infobox__animation--bigger')) {
		animationBoxHeight = '142px';
	}

	$('.slide.active .slide__infobox__animation').animate({
		height: animationBoxHeight
	}, 1500, function() {
		// Animation complete.
	});

	this.slidesWrapper.on('click', '.slide > div', function(event) {
		var link = $(event.currentTarget).data('slideLink');
		var blank = $(event.currentTarget).data('slideLinkBlank');
		if (!link) {
			return false;
		}
		if (blank) {
			window.open(link);
		} else {
			window.location.href = link;
		}
	});

	this.slidesWrapper.on('click', '.slide > div a', function(event) {
		$('body').trigger('WEBSLIDER_INSIDE_ANCHOR_CLICKED', [event.currentTarget]);
	});
};

WebSlider.prototype.getPreviousSlideIndex = function(index) {
	index = index || 1;
	var previousSlide = this.actualSlide - index;

	if (previousSlide < 0) {
		previousSlide = this.options.data.length - index + this.actualSlide;
	}
	return previousSlide;
};
WebSlider.prototype.getNextSlideIndex = function(index) {
	var nextSlide = this.actualSlide + index;

	if (nextSlide > this.options.data.length - 1) {
		nextSlide = this.actualSlide - this.options.data.length + index;
	}
	return nextSlide;
};

/**
 * render controls
 */
WebSlider.prototype.renderControls = function() {
	this.controlArrows = (this.options.controlArrows) ? this.renderControlArrows() : null;
	this.controlPoints = (this.options.controlPoints) ? this.renderControlPoints() : null;

	if (this.controlArrows) {
		this.sliderWrapper.append(this.controlArrows);
		this.$prevArrow = $('.control-previous', this.sliderWrapper);
		this.$nextArrow = $('.control-next', this.sliderWrapper);
		this.decorControlArrows();
		this.bindControlArrows();
	}

	if (this.controlPoints) {
		this.$t.append(this.controlPoints);
		this.bindControlPoints();
		this.updateControlPoints(this.actualSlide);
	}
};

/**
 * renders control arrows
 */
WebSlider.prototype.renderControlArrows = function() {
	var str = '';
	str += '<a class="control control-previous" href="javascript:void(0)"><span class="visible-over"></span><span class="title"><span class="wrapper"></span></span></a>';
	str += '<a class="control control-next" href="javascript:void(0)"><span class="visible-over"></span><span class="title"><span class="wrapper"></span></span></a>';
	return str;
};

// update widths of control arrows
WebSlider.prototype.decorControlArrows = function() {
	var sideWidthTotal = this.$t.outerWidth() - this.slidesWrapper.outerWidth();
	var leftSideWidth = parseInt(sideWidthTotal/2);
	var rightSideWidth = parseInt(sideWidthTotal/2);

	if (leftSideWidth + rightSideWidth < sideWidthTotal) {
		leftSideWidth++;
	}

	$('.control:eq(0)', this.sliderWrapper).width(leftSideWidth);
	$('.control:eq(1)', this.sliderWrapper).width(rightSideWidth);
};

/**
 * bind action to control arrows
 */
WebSlider.prototype.bindControlArrows = function() {
	var self = this;

	$('a.control', this.$t).bind('click', function(event) {
		event.preventDefault();
		if (self._animationInProgress) {
			return false;
		}

		clearTimeout(this._changeTimer);

		if ($(event.currentTarget).hasClass('control-previous')) {
			self.rotate(self.actualSlide, 'prev');
		}

		if ($(event.currentTarget).hasClass('control-next')) {
			self.rotate(self.actualSlide, 'next');
		}
	});
};

/**
 * renders control points
 */
WebSlider.prototype.renderControlPoints = function() {
	var str = '<ul class="control-points">';

	for (var i = 0; i < this.options.data.length; i++) {
		str += '<li>' + i + '</li>'
	}

	str += '</ul>';
	return str;
};

/**
 * bind action to control points
 */
WebSlider.prototype.bindControlPoints = function() {
	var self = this;
	clearTimeout(this._changeTimer);

	$('.control-points>li', this.$t).bind('click', function() {
		self.changeSlide(self.actualSlide, $(this).text());
	});
};

/**
 *
 */
WebSlider.prototype.rotate = function(from, direction) {
	this._animationInProgress = true;

	var newSlide = this.actualSlide;
	clearTimeout(this._changeTimer);

	if (direction == 'prev') {
		newSlide--;
		newSlide = (newSlide < 0) ? this.options.data.length - 1 : newSlide;
	}

	if (direction == 'next') {
		newSlide++;
		newSlide = (newSlide >= this.options.data.length) ? 0 : newSlide;
	}

	this.changeSlide(this.actualSlide, newSlide,  direction);
};

/**
 *
 * @param from
 * @param to
 * @param direction
 */
WebSlider.prototype.changeSlide = function(from, to, direction) {

	var self_ = this;

	if (from == to) {
		return false;
	}

	this.$t.trigger('WEBSLIDER_ANIMATION_START', [direction]);

	var $newNextSlide = this._slides[this.getNextSlideIndex(2)]; // retrieve actual + 2 slide
	var $nextSlide = this._slides[this.getNextSlideIndex(1)]; // retrieve actual + 1 slide
	var $actualSlide = this._slides[this.actualSlide]; // retrieve actual
	var $previousSlide = this._slides[this.getPreviousSlideIndex(1)]; // retrieve actual - 1 slide
	var $newPreviousSlide = this._slides[this.getPreviousSlideIndex(2)]; //  retrieve actual - 2 slide

	var $newSubSlide = $('.js_state-active', self_._slides[to]).clone().addClass('js_webslider-added');
	var $oldSubSlide = $('.js_state-active', $actualSlide);
	var $oldSubSlideForPrev = $('.js_state-inactive', $actualSlide);
	var $prevOldSlide, $nextOldSlide = null;

	if (direction == 'next') {

		// next slide
		$newNextSlide.css({ left: '200%', right: 'auto'}).show().addClass('next-slide').animate({ left: '100%'}, self_.options.slideAnimationTime, self_.options.slideAnimationEasing);
		$nextSlide.animate({ left: 0 }, self_.options.slideAnimationTime, self_.options.slideAnimationEasing);

		// actual slide
		$newSubSlide.css({ left: '100%'}).appendTo(self_._slides[from]);
		$newSubSlide.animate({ left: 0 }, self_.options.slideAnimationTime, self_.options.slideAnimationEasing);
		$oldSubSlide.animate({ left: '-100%' }, self_.options.slideAnimationTime, self_.options.slideAnimationEasing);

		// prev slide
		$prevOldSlide = $oldSubSlideForPrev.clone().addClass('js_webslider-added').appendTo($previousSlide).css({ left: '100%'});
		$prevOldSlide.animate({ left: 0 }, self_.options.slideAnimationTime, self_.options.slideAnimationEasing);
		$('.js_state-inactive:first', $previousSlide).animate({ left: '-100%' }, self_.options.slideAnimationTime, self_.options.slideAnimationEasing, function() {
			window.setTimeout(function() {
				self_.$t.trigger('WEBSLIDER_ANIMATION_COMPLETE', ['next']);
			}, 10);
		});
	}

	if (direction == 'prev') {

		// prev slide
		$newPreviousSlide.css({ left: 'auto', right: '200%'}).show().addClass('previous-slide').animate({ right: '100%' }, self_.options.slideAnimationTime, self_.options.slideAnimationEasing);
		$previousSlide.animate({ right: 0 }, self_.options.slideAnimationTime, self_.options.slideAnimationEasing);

		// actual slide
		$newSubSlide.css({ left: '-100%'}).appendTo(self_._slides[from]);
		$newSubSlide.animate({ left: 0 }, self_.options.slideAnimationTime, self_.options.slideAnimationEasing);
		$oldSubSlide.css({ left: 0 }).animate({ left: '100%' }, self_.options.slideAnimationTime, self_.options.slideAnimationEasing);

		// next slide
		$nextOldSlide = $oldSubSlideForPrev.clone().addClass('js_webslider-added').appendTo($nextSlide).css({ left: '-100%'});
		$nextOldSlide.animate({ left: 0 }, self_.options.slideAnimationTime, self_.options.slideAnimationEasing);
		$('.js_state-inactive:first', $nextSlide).animate({ left: '100%' }, self_.options.slideAnimationTime, self_.options.slideAnimationEasing, function() {
			window.setTimeout(function() {
				self_.$t.trigger('WEBSLIDER_ANIMATION_COMPLETE', ['prev']);
			}, 10);
		});
	}

	this.$t.off('WEBSLIDER_ANIMATION_COMPLETE').on('WEBSLIDER_ANIMATION_COMPLETE', function(event, dir) {

		self_._animationInProgress = false;
		$('.js_webslider-added', self_.$t).remove();

		$('.slide > div', self_.$t).css({ left: 0, right: 'auto' });
		if (dir === 'next') {
			$actualSlide.removeClass('active').addClass('previous-slide');
			$nextSlide.hide().removeClass('next-slide').addClass('active').show();
			$previousSlide.hide().removeClass('previous-slide');
		} else if ( dir === 'prev') {
			$actualSlide.removeClass('active').addClass('next-slide');
			$previousSlide.hide().removeClass('previous-slide').addClass('active').show();
			$nextSlide.hide().removeClass('next-slide');
		}
		$('.slide__infobox__animation', $actualSlide).removeAttr('style');
		var animationBoxHeight = '42px';
		if ($('.slide.active .slide__infobox__animation').hasClass('slide__infobox__animation--bigger')) {
			animationBoxHeight = '142px';
		}
		$('.slide.active .slide__infobox__animation').animate({
			height: animationBoxHeight
		}, 1000, function() {
			// Animation complete.
		});

		self_.actualSlide = to;

		$nextSlide = self_._slides[self_.getNextSlideIndex(1)]; // retrieve actual + 1 slide
		$actualSlide = self_._slides[self_.actualSlide]; // retrieve actual
		$previousSlide = self_._slides[self_.getPreviousSlideIndex(1)]; // retrieve actual - 1 slide

		$nextSlide.css({ left: '100%'}).show();
		$previousSlide.css({ right: '100%', left: 'auto'}).show();

		self_.$t.trigger('WEBSLIDER_ROTATION_COMPLETE', [self_.options.data[self_.getPreviousSlideIndex(1)], self_.options.data[self_.getNextSlideIndex(1)]]);

		if (self_.options.autostart) {
			self_.startRotation();
		}
	});

};


/**
 * start
 */
WebSlider.prototype.startRotation = function() {
	var self = this;
	clearTimeout(this._changeTimer);

	this._changeTimer = setTimeout(function() {
		self.rotate(self.actualSlide, 'next');
	}, self.options.slideTime);
};

/**
 * sets the right controlPoint active
 */
WebSlider.prototype.updateControlPoints = function(index) {
	if (this.options.controlPoints) {
		$('.control-points li', this.$t).removeClass('active');
		$('.control-points li:eq(' + index + ')', this.$t).addClass('active');
	}
};

WebSlider.prototype.isTouchDevice = function() {
	return 'ontouchstart' in document.documentElement;
};


/**
 *
 */
WebSlider.prototype.bindTouchEvents = function() {
	var self_ = this;
	this.$t.bind('swipeone', function(e, je) {
		if (self_._animationInProgress) {
			return false;
		}
		if (Math.abs(je.delta[0].lastY) > 50) {
			return false;
		}
		if (je.direction.lastX == 1) {
			self_.rotate(self_.actualSlide, 'prev');
		}

		if (je.direction.lastX == -1) {
			self_.rotate(self_.actualSlide, 'next');
		}
	});
};

/**
 * getter for external use (we need to save actual slide to browser history in order to renew it on history.back() )
 * @returns {number|*}
 */
WebSlider.prototype.getActualSlide = function() {
	return this.actualSlide;
};

/**
 * decide, which methods will be "public"
 */
var API = {
	decorControlArrows: WebSlider.prototype.decorControlArrows,
	getActualSlide: WebSlider.prototype.getActualSlide,
	rotate: WebSlider.prototype.rotate
};

/**
 * plugin go live
 * @param value - first param - decides, which action shall be executed
 *         if object - apply plugin with these settings to an selector's elements, if they are clean (plugin not applied yet)
 *         if string && in API object - run method named as this value with all args[index > 0]
 * @return {*}
 */
$.fn[PLUGIN_NAME] = function(value) {
	var args = arguments;

	return this.each(function() {
		var $this = $(this);

		// get plugin instance
		var plugin = $this.data('plugin_' + PLUGIN_NAME);

		// if there's not, create one
		if (!plugin) {
			plugin = new WebSlider(this, value);
			$this.data('plugin_' + PLUGIN_NAME, plugin);
		}
		// if there is and first parameter is in predefined API methods, call it with rest of params
		else if (API[value]) {
			plugin[value].apply(plugin, Array.prototype.slice.call(args, 1));
		}
	});
};



// WEBPACK FOOTER //
// ./fe/web-default/src/js/web/jquery.webslider.js